import React from "react";
import Hero from "../../common/Hero";
import BlogImage from "../../assests/images/terms.jpg";
import Footer from "../../common/Footer";
import Navbar from "../../common/Navbar";

function TermsAndConditions() {
  return (
    <>
      <Navbar />
      {/* Hero Section */}
      <Hero text="Terms" text1="& Conditions" image={BlogImage} />

      <div className="bg-gray-50 min-h-screen flex flex-col">
        {/* Title Header */}
        <div className="text-center py-10 px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800">
            Terms and Conditions
          </h1>
          <p className="text-md md:text-lg mt-2 text-gray-600">
            Effective Date: November 27, 2024
          </p>
        </div>

        {/* Content Area */}
        <div className="flex-grow px-4 md:px-8 pb-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6 md:p-10">
            {/* Section: Introduction */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Welcome to MF Carpet and Blinds!
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed text-justify">
              These terms and conditions outline the rules and regulations for the use of MF Carpet and Blinds’ website and services. 
              By accessing this website or engaging with our products and installation services, you agree to be bound by these terms.
            </p>

            {/* Section: Acceptance */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              1. Acceptance of Terms
            </h3>
            <p className="text-gray-700 leading-relaxed text-justify">
              By visiting our website, placing an order, or booking an installation, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. 
              If you disagree with any part of these terms, please do not use our services.
            </p>

            {/* Section: Services */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              2. Services Offered
            </h3>
            <p className="text-gray-700 leading-relaxed text-justify">
              MF Carpet and Blinds specializes in the supply, measurement, and installation of carpets, blinds, and window furnishings. 
              We also provide carpet cleaning, repairs, and the removal of old flooring. 
              Service details and pricing are confirmed at the time of quotation or booking.
            </p>

            {/* Section: Responsibilities */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              3. Customer Responsibilities
            </h3>
            <ul className="text-gray-700 list-disc pl-6 leading-relaxed space-y-1">
              <li>Provide accurate contact and property details when booking a service.</li>
              <li>Ensure clear access to the installation area on the agreed date.</li>
              <li>Make prompt payments as outlined in your invoice or quote.</li>
              <li>Review all product and color choices before confirming your order, as custom-made items cannot be refunded once produced.</li>
            </ul>

            {/* Section: Cancellation */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              4. Cancellations and Refunds
            </h3>
            <p className="text-gray-700 leading-relaxed text-justify">
              Orders for custom blinds and carpets cannot be cancelled once production has started. 
              For standard products, cancellations made within 24 hours of order placement may be accepted. 
              Refunds are processed according to our refund policy and may exclude non-refundable deposits or production costs.
            </p>

            {/* Section: Warranty and Liability */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              5. Warranty and Limitation of Liability
            </h3>
            <p className="text-gray-700 leading-relaxed text-justify">
              All installations by MF Carpet and Blinds are covered by a workmanship warranty. 
              Product warranties are provided by the respective manufacturers. 
              We are not liable for damage resulting from misuse, improper care, or unauthorized modifications. 
              To maintain warranty coverage, ensure that all products are used and maintained according to manufacturer recommendations.
            </p>

            {/* Section: Changes */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              6. Modifications to Terms and Services
            </h3>
            <p className="text-gray-700 leading-relaxed text-justify">
              MF Carpet and Blinds reserves the right to update these Terms and Conditions or modify its services at any time without prior notice. 
              Any changes will be reflected on this page, and continued use of our services implies acceptance of the updated terms.
            </p>

            {/* Section: Contact */}
            <h3 className="text-xl font-bold text-gray-800 mt-6 mb-2">
              7. Contact Information
            </h3>
            <p className="text-gray-700 leading-relaxed text-justify">
              For any questions, feedback, or clarification regarding these Terms and Conditions, please contact us:
            </p>
            <p className="text-gray-700 mt-2 font-medium">
              📧 Email: <span className="underline">mfblindscarpet@gmail.com</span> <br />
              ☎️ Phone: +44-1234-567890 <br />
              📍 Unit 8, Elder way, water side drive, slough SL3 6EP London UK
            </p>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default TermsAndConditions;
